import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VCard,{staticClass:"pa-1",attrs:{"flat":""}},[_c(VTabs,{attrs:{"centered":""}},[_c(VTab,{attrs:{"href":"#tab-tabela-materia-prima"}},[_c(VIcon,{attrs:{"left":""}},[_vm._v("mdi-clipboard-list-outline")]),_vm._v("\n        Listas de preços\n      ")],1),_c(VTabItem,{staticClass:"ma-0",attrs:{"value":"tab-tabela-materia-prima"}},[_c('TabelaCapaListas',{attrs:{"pedido_selecionado":{}}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }